module.exports = __webpack_public_path__ + "img/buenos_aires_colegiales.3fab5780.jpg";